<!-- Usuarios.svelte -->

<script>
	import Form from './Form.svelte'
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();
	
	import {execQuery} from '../csql.js'

	let ds = []
	let loading=false
	let page = 0
	let rpp = 10
	let eof= false
	let where_clause = ''
	let order_clause = ''

	let DS = []

	let search_pattern = ''

	$: {
		page=0
		DS=[]
		getData()
	}



	const getData = async () => {

		loading = true 
		let query = `select * from usuarios where 1=1  ${where_clause} ${order_clause} order by id asc limit ${page*rpp},${rpp}`
		const data = await execQuery({query})
		loading= false
		let ds = data.data[0] || []
		eof = ds.length<rpp?true:false
		DS = [...ds]
	}

	function next_page(){
		if(!eof){
			page++
			getData()
		}
	}
	

	function prev_page(){
		if(page>0){
			page--
			getData()
		}
	}
	
	let editing = false
	let item_edited = {}

	function editar(itm){
		item_edited=itm
		editing = true
	}

	function insertar(){
		item_edited = {}
		editing = true
	}

	function buscar(){
		page=0
		where_clause = ` and ( email like  '%${search_pattern}%' or nombre like  '%${search_pattern}%' or apellido like  '%${search_pattern}%' ) `
		getData()
	}

	function reset_search(){
		search_pattern = ''
		where_clause = ''
		getData()
	}

	function salir(){
		dispatch('close')
	}

</script>


<div class="container">
	<div class="row v-center" style="margin-top: 7px;">
		<div class="col-sm-8">
			<span class="button" on:click={salir}>&hookleftarrow;</span>
			<span class="button" on:click={insertar}>&xuplus;</span>
			<input class="button" bind:value={search_pattern} placeholder="Buscar..." on:change={buscar}>
			{#if search_pattern}
				<span class="button" on:click={reset_search} title="Finalizar busqueda">&Cross;</span>
			{/if}
		</div>
		<div class="col-sm-4 text-right">
			<span class="button" on:click={prev_page}>&laquo;</span>
			<span>{page}</span>
			<span class="button" on:click={next_page}>&raquo;</span>
			<!-- <span class="text-white rounded bg-gray-500" on:click={reset_search}>&olarr;</span> -->
		</div>
	</div>
	{#if !loading}
		{#each DS as item, index}
			<div class="row v-center border" style="margin-top:7px;text-decoration:{!item.activo?'line-through':''};">
				<div class="col-sm-12">{item.email}</div>
				<div class="col-sm-9">{item.nombre||''} {item.apellido||''}</div>
				<div class="col-sm-2">{item.tipo}</div>
				<div class="col-sm-1 text-right">
					<button class="" style="margin:0;padding:1px 4px;" title="Modificar" on:click={()=>editar(item)}>&boxbox;</button>
				</div>
			</div>
		{/each}	
	{:else}
		<span>Actualizando...</span>
	{/if}
</div>

{#if editing}
	<Form bind:item={item_edited} bind:visible={editing} on:updated={getData}/>
	
{/if}


<style>
	.button{
		margin:0;
		padding:1px 6px;
	}
	
</style> 